
import { Ref, computed, defineComponent, reactive, ref, toRef } from "vue";
import SearchDropdown from "./SearchDropdown.vue";
import { HTMLInputEvent } from "../@types/vue";
import { useSearchModuleStore } from "../store/searchModule";
import { useElementVisibility } from "@vueuse/core";

export default defineComponent({
    props: ["criticalCss", "afterCss", "appCss"],
    setup(props, context) {
        // const inst = getCurrentInstance();
        // if (inst) {
        //     Object.assign(inst.appContext, vueApp._context);
        //     Object.assign(inst.appContext.provides, vueApp._context.provides);
        // }
        const inputFocused = ref(false);
        const searchModuleStore = useSearchModuleStore();
        // const query = ref(searchModuleStore.getQuery);

        const setQuery = (payload: Event) => {
            const typedPayload: HTMLInputEvent = payload as HTMLInputEvent;
            // console.log("set query", typedPayload?.target?.value);
            searchModuleStore.setQuery(typedPayload?.target?.value || "");
        };
        // onMounted(() => {
        //     // console.log(props.criticalCss);
        //     // console.log(`the component is now mounted.`);
        // });
        const mainElement: Ref<HTMLElement | undefined> = ref();
        const isMainElementVisible = useElementVisibility(mainElement);

        return { mainElement, isMainElementVisible, inputFocused, setQuery, searchModuleStore };
    },
    components: { SearchDropdown }
});
